import { React, useEffect, useReducer, useRef, useState,  } from 'react';

import { Row, Col, Typography, Space, Table, Empty, message, Spin, Popover, Avatar, Card, Button, Modal, Form, Input, Tag, Select, DatePicker, InputNumber, Switch, Upload, Tooltip } from 'antd';
import { Content } from 'antd/es/layout/layout';
import { InfoOutlined, PlusOutlined, EditOutlined, DeleteOutlined, UnorderedListOutlined, UploadOutlined} from '@ant-design/icons';
import {  ADD_BATCH, ADD_BATCH_ERROR, ADD_BATCH_SUCCESS, BATCH_DETAILS, BATCH_DETAILS_ERROR, BATCH_DETAILS_SUCCESS, DELETE_BATCH, DELETE_BATCH_ERROR, DELETE_BATCH_SUCCESS, EDIT_BATCH, EDIT_BATCH_ERROR, EDIT_BATCH_SUCCESS, EVENT_BATCH_LIST, EVENT_BATCH_LIST_ERROR, EVENT_BATCH_LIST_SUCCESS} from './constants';
import axios from 'axios';
import exteventbatchreducer from './reducer';
import { useNavigate } from 'react-router-dom';
import englan from '../../../english.json';
import germanlan from '../../../german.json';
import arabiclan from '../../../arabic.json';
import frenchlan from '../../../french.json';
import hindilan from '../../../hindi.json';
import malayalamlan from '../../../malayalam.json';
import { useFormik } from 'formik';
import dayjs from 'dayjs';
import { notification } from 'antd';
import { useAuth } from '../../Context';
const { Title } = Typography;
import logo from '../../../../src/images/logo.png';
import UnauthorizedError from '../../unauthorizedError';
import Search from 'antd/es/input/Search';
import moment from 'moment';



export default function ExternalEventVerifierBatch() {

	const dashboardtype = process.env.REACT_APP_IDENTIFIER;
	const initalState = { batch : [], details: null, loading: false, error: false, pagination: { total: 0, limit: 10, skip: 0, current:1 }};
	const [data, dispatch] = useReducer(exteventbatchreducer, initalState);
	const apiUrl = localStorage.getItem(`${dashboardtype.toUpperCase()}_API_URL`);
	const api = apiUrl && apiUrl ? apiUrl : process.env.REACT_APP_CORE_HOST;
	const [openAddDrawer, setOpenAddDrawer] = useState(false);
	const [openEditDrawer, setOpenEditDrawer] = useState(false);
	const [showDeleteBatchModal, setShowDeleteBatchModal] = useState(false);
	const [isTokenModalOpen, setIsTokenModalOpen] = useState(true);
	const [token, setToken] = useState('');
	const auth_TOKEN = sessionStorage.getItem('API_TOKEN') ? sessionStorage.getItem('API_TOKEN') : null; 
	useAuth();
	
	const navigate = useNavigate();
	const [form] = Form.useForm();	
	const formDataRef = useRef(new FormData());

	const envTimeout = process.env.REACT_APP_TIMEOUT == undefined || process.env.REACT_APP_TIMEOUT == 'undefined' ? 5000 : process.env.REACT_APP_TIMEOUT;
	const timeout = localStorage.getItem(`${dashboardtype.toUpperCase()}_TIMEOUT`) == 'null' || localStorage.getItem(`${dashboardtype.toUpperCase()}_TIMEOUT`) == 'undefined' ? parseInt(envTimeout) :  parseInt(localStorage.getItem(`${dashboardtype.toUpperCase()}_TIMEOUT`));
	const langid = localStorage.getItem(`${dashboardtype.toUpperCase()}_LANGUAGE_ID`) && localStorage.getItem(`${dashboardtype.toUpperCase()}_LANGUAGE_ID`) ? parseInt(localStorage.getItem(`${dashboardtype.toUpperCase()}_LANGUAGE_ID`)) : 2;
	const langdata = langid && langid ==1 ? arabiclan : langid ==2 ? englan : langid ==3 ? frenchlan : langid ==4 ? germanlan : langid ==5 ? hindilan : langid == 6 ? malayalamlan : englan;
	// const featuresModule = JSON.parse(localStorage.getItem(`${dashboardtype.toUpperCase()}_FEATURES_MODULE_DASHBOARD`));
	const pipelineId = localStorage.getItem(`${dashboardtype.toUpperCase()}_pipelineId`) ? localStorage.getItem(`${dashboardtype.toUpperCase()}_pipelineId`) : 1;
	// const {pidsData, getPids, channelData, getChannels,getAllEvents,eventsData} = useAuth();
	const { RangePicker } = DatePicker;
	const customstart = '00:00:00';
	const customend = '23:59:59';
	const [startDate, setStartDate] = useState(customstart ? moment(new Date(new Date().getFullYear(), new Date().getMonth(),  new Date().getDate() - 30), 'YYYY-MM-DD HH:mm:ss').set({ hour: moment(customstart, 'HH:mm:ss').hour(), minute: moment(customstart, 'HH:mm:ss').minute(),second: moment(customstart, 'HH:mm:ss').second(), millisecond: 0}) : new Date(new Date().getFullYear(), new Date().getMonth(),  new Date().getDate() - 30));
	const [endDate, setEndDate] = useState(customend ? moment(new Date(new Date().getFullYear(), new Date().getMonth(),  new Date().getDate()), 'YYYY-MM-DD HH:mm:ss').set({ hour: moment(customend, 'HH:mm').hour(), minute: moment(customend, 'HH:mm').minute(),second: moment(customend, 'HH:mm:ss').second(), millisecond: 59}) : new Date(new Date().getFullYear(), new Date().getMonth(),  new Date().getDate()));
	const [reportFilter, setFilter] = useState({pidsinfoId: null, channelId: null}); 
	const settingsdateformat = 'YYYY-MM-DD' ;
	const settingstimeformat = 'HH:mm:ss a';
	const [fiber,setfibermetric] = useState();
	const [nameSearch, setNameSearch] = useState(null);
	const [activitySearch, setactivitySearch] = useState(null);


	if (dashboardtype != 'oneview') {
		return <UnauthorizedError />;
	}


	// let pids = [];

	
	// pidsData && pidsData.map((pid)=>{
	// 	pids.push({
	// 		value:pid.id,
	// 		label:pid.name.toUpperCase()});
	// });

	useEffect(() => {
		const savedToken = sessionStorage.getItem('API_TOKEN');

		if (!savedToken) {
			setIsTokenModalOpen(true); // open modal
		} else {
			setIsTokenModalOpen(false);
		}
	}, []);

	const fibermetricoptions =[
		{value:'Index',
			label:'Index'
		},
		{value:'Length',
			label:'Length'
		},
	];


	const analysisTypeoptions =[
		{value:'Event',
			label:'Event'
		},
		{value:'Alarm',
			label:'Alarm'
		},
	];
    
	const fileref  = useRef(null);

	const fileUploader = ({ fileList }) => {
		if (fileList.length > 0 && fileList[0].originFileObj) {
			fileref.current = fileList[0].originFileObj; // ← store file separately
		}
	};


	// let referenceeventoptions=[];
    
	// eventsData && eventsData.map((item) => {
	// 	referenceeventoptions.push({
	// 		value : item.id,
	// 		label: item.eventType
	// 	});
	// });

	
	// pids.sort((a, b) => { return a.value - b.value; });

	// let channels=[];

	// channelData && channelData.map((item) => {
	// 	channels.push({
	// 		value : item.id,
	// 		label : item.name,
	// 	});
	// });

	const filterOption = (input, option) =>
		(option?.label ?? '').toLowerCase().includes(input.toLowerCase());

	const columns = [

		
		{
			title: `${langdata && langdata.Name ? langdata.Name:'Name'}`,
			dataIndex: 'name',
			key: 'name',
			render : (_,text) =>(
				<>
					
					<a onClick={()=> navigate(('/exteventverifier'),{state : {id:text.id, accesstoken:auth_TOKEN}})}>
						{text.name} 
					</a>
		
				</>
			)
		},
		{
			title: `${langdata && langdata.PIDS ? langdata.PIDS:'PIDS'}`,
			dataIndex: 'pidsname',
			key: 'pidsname',
		},
		{
			title: `${langdata && langdata.ChannelName ? langdata.ChannelName:'Channel Name'}`,
			dataIndex: 'channelname',
			key: 'channelname',
			
		},
		{
			title: `${langdata && langdata.StartDate ? langdata.StartDate:'Start date'}`,
			dataIndex: 'newstartdate',
			key: 'newstartdate',

		}
		,
		{
			title: `${langdata && langdata.EndDate ? langdata.EndDate:'End date'}`,
			dataIndex: 'newenddate',
			key: 'newenddate',
		
		},
		{
			title: `${langdata && langdata.ReferenceEvent ? langdata.ReferenceEvent:'Reference Event'}`,
			dataIndex: 'referenceevent',
			key: 'referenceevent'
		},
		{
			title: `${langdata && langdata.ConfirmedEvent ? langdata.ConfirmedEvent:'Confirmed Event'}`,
			dataIndex: 'confirmedEvent',
			key: 'confirmedEvent',
			render: (event, record) => {
				if (record?.status === 'New') {
					return <Tag color="blue">TBU</Tag>;
				}
		
				if (record?.status === 'Inprogress') {
					return <Tag color="yellow">Processing</Tag>;
				}
		
				if (event == null || event === '' || event === 'No Data') {
					return <Tag color="yellow">No Data</Tag>;
				}
		
				return <Tag color="green">{event}</Tag>;
			}
			
		}
		,
		{
			title: `${langdata && langdata.Confidence ? langdata.Confidence:'Confidence'}`,
			dataIndex: 'confirmedEventConfidence',
			key: 'confirmedEventConfidence',
					
		},
				
		{
			title: `${langdata && langdata.dataUpload ? langdata.dataUpload:'Data Upload'}`,
			dataIndex: 'isdataUploaded',
			key: 'isdataUploaded',
			render: (_, { isdataUploaded }) => (
				<>
					<Tag color={isdataUploaded === true ?'green' : 'red'} >
						{isdataUploaded === true ? 'true' : 'false'}
					</Tag>
				</>
			),
						
		},
		{
			title: langdata&&langdata.Status?langdata.Status:'Status',
			dataIndex: 'status',
			key: 'status',
			render: (_, { status }) => {
				
				let color = '';
				if(status === 'New') color = 'blue';
				if(status==='Inprogress') color ='yellow';
				if(status ==='Completed') color = 'green';
				if(status=== 'Failed') color = 'red';
								
				return (<>
					<Tag color={color} >
						{status}
					</Tag>
				</>);
			},
									
		},
		{
			title: `${langdata && langdata.dispatched ? langdata.dispatched:'Dispatched'}`,
			dataIndex: 'send',
			key: 'send',
			render: (_, { send }) => (
				<>
					<Tag color={send === true ?'green' : 'red'} >
						{send === true ? 'true' : 'false'}
					</Tag>
				</>
			),
						
		},
		
		
		{
			title: `${langdata && langdata.timeWindow ? langdata.timeWindow:'Time Window (sec)'}`,
			dataIndex: 'timeWindow',
			key: 'timeWindow',
			render: (_, record) => {
				return record.timeWindow ? record.timeWindow : 0;
			}
		},
		{
			title: `${langdata && langdata.sampleSec ? langdata.sampleSec:'Sample Sec (sec)'}`,
			dataIndex: 'sampleSec',
			key: 'sampleSec',
			render: (_, record) => {
				return record.sampleSec ? record.sampleSec : 0;
			}
		},

		{
			title: `${langdata && langdata.webhookUrl ? langdata.webhookUrl:'Webhook Url'}`,
			dataIndex: 'webhookUrl',
			key: 'webhookUrl',
			render: (text) => (
				text?  
					<Popover overlayStyle={{ width : text.length >= 80 ?  '80%' : '' }}  title={langdata && langdata.Description ? langdata.Description :'Description'} content={text} trigger="hover">
			
						{ text.length >= 80 ? text.slice(0,80) + '...' : text.slice(0,80)}
					
					</Popover> :'No Data'
			)
		
		},
		{
			title: `${langdata && langdata.fiberMetric ? langdata.fiberMetric:'Fiber Metric'}`,
			dataIndex: 'fiberMetric',
			key: 'fiberMetric',
		
		},{
			title: `${langdata && langdata.analysisType ? langdata.analysisType:'Analysis Type'}`,
			dataIndex: 'analysisType',
			key: 'analysisType',
		
		},

		// {
		// 	title: `${langdata && langdata.dataPath ? langdata.dataPath:'Data Path'}`,
		// 	dataIndex: 'dataPath',
		// 	key: 'dataPath',
		// 	render: (_, record) => {
		// 		return record.dataPath ? record.dataPath : 'No Data';
		// 	}

		// },
		{
			title: `${langdata && langdata.binSize ? langdata.binSize:'Bin size'}`,
			dataIndex: 'binSize',
			key: 'binSize',
		},
		{
			title: `${langdata && langdata.StartPosition ? langdata.StartPosition:'Start Position'}`,
			dataIndex: 'startPos',
			key: 'startPos',
		},
		{
			title: `${langdata && langdata.AmplitudeNumber ? langdata.AmplitudeNumber:'Amplitude Number'}`,
			dataIndex: 'amplitudeNumber',
			key: 'amplitudeNumber',
		},
		// {
		// 	title: `${langdata && langdata.dataUpload ? langdata.dataUpload:'Data Upload'}`,
		// 	dataIndex: 'isdataUploaded',
		// 	key: 'isdataUploaded',
		// 	render: (_, { isdataUploaded }) => (
		// 		<>
		// 			<Tag color={isdataUploaded === true ?'green' : 'red'} >
		// 				{isdataUploaded === true ? 'true' : 'false'}
		// 			</Tag>
		// 		</>
		// 	),
		
		// },
		// {
		// 	title: langdata&&langdata.Status?langdata.Status:'Status',
		// 	dataIndex: 'status',
		// 	key: 'status',
		// 	render: (_, { status }) => {

		// 		let color = '';
		// 		if(status === 'New') color = 'blue';
		// 		if(status==='Inprogress') color ='yellow';
		// 		if(status ==='Completed') color = 'green';
		// 		if(status=== 'Failed') color = 'red';
				
		// 		return (<>
		// 			<Tag color={color} >
		// 				{status}
		// 			</Tag>
		// 		</>);
		// 	},
					
		// },
		// {
		// 	title: `${langdata && langdata.dispatched ? langdata.dispatched:'Dispatched'}`,
		// 	dataIndex: 'send',
		// 	key: 'send',
		// 	render: (_, { send }) => (
		// 		<>
		// 			<Tag color={send === true ?'green' : 'red'} >
		// 				{send === true ? 'true' : 'false'}
		// 			</Tag>
		// 		</>
		// 	),
		
		// },

		{
			title: `${langdata && langdata.Actions ? langdata.Actions:'Actions'}`,
			key: 'attachmentUrls',
			align:'center',
			render: (_,record) => (
				<>
					<Space style={{justifyContent:'center',display:'flex'}} size="middle">
						<a title={langdata && langdata.Edit ? langdata.Edit:'Edit'}  disabled={record.status!= 'New'} onClick={record.status === 'New' ?()=>showEditDrawer(record) : null}><EditOutlined/></a>
						<a title={langdata && langdata.Delete ? langdata.Delete :'Delete'}  disabled={record.status!= 'New'} onClick={  record.status === 'New' ? ()=>openDeleteAssetsModal(record) : null}><DeleteOutlined /></a>
					</Space>
				</>
			)
		}
	
	];

	

	
	// useEffect(() => {
	// 	if(featuresModule.shiftManagementEnabled == false) {
	// 		navigate('/dashboard');
	// 	}
	// 	if(!authtoken){
	// 		navigate('/');
	// 	}
	
	// },[authtoken]);

	useEffect(() => {
		window.scrollTo(0, 0);
		localStorage.setItem(dashboardtype.toUpperCase()+ '_ACTIVE_MENU_ITEM' , 4032);

	}, []);
	
	useEffect(() => {
		const savedToken = sessionStorage.getItem('API_TOKEN');
		if(savedToken){
			loadEventBatch(1);
		}
	}, [isTokenModalOpen,nameSearch,activitySearch,startDate,endDate]);


	const loadEventBatch = (pagination) => {
		
		let _pagination = { };
		_pagination.total = data.pagination.total ? data.pagination.total : 0;
		_pagination.limit = pagination.pageSize ? pagination.pageSize : 10;
		_pagination.skip =  pagination.current    ? parseInt((pagination.current-1) * pagination.pageSize) : 0;
		_pagination.pageSize =  pagination.pageSize ? pagination.pageSize : 10;
		let nameParam = '';
		let activityParam = '';

		if(nameSearch){
			nameParam=`&name[$ilike]=%${nameSearch}%`;
		}
		if(activitySearch){
			activityParam = `&confirmedEvent=${activitySearch}`;
		}

		if(auth_TOKEN){
			dispatch({ type : EVENT_BATCH_LIST});
			let config = {
				method: 'get',
				maxBodyLength: Infinity,
				url: `${api}/eventverifierbatch?$limit=${_pagination.limit}&$skip=${_pagination.skip}&pipelineId=${pipelineId}&$sort[createdAt]=-1&createdAt[$gte]=${moment.utc(startDate).format('YYYY-MM-DD HH:mm:ss')}&createdAt[$lte]=${moment.utc(endDate).format('YYYY-MM-DD HH:mm:ss')}${nameParam}${activityParam}`,
				timeout: timeout,
				headers: { 
					'apikey':`${auth_TOKEN}`
				},
			};
    
			axios.request(config)
				.then((response) => {
					if (response.status === 200) {
						dispatch({ type : EVENT_BATCH_LIST_SUCCESS,page: pagination.current, pageSize : pagination.pageSize, payload : response.data});
					}else {
						dispatch({ type : EVENT_BATCH_LIST_ERROR});
						message.error('Invalid Token');
					}
				})

				.catch((error) => {
					console.log(error);
					dispatch({ type : EVENT_BATCH_LIST_ERROR});
					if(error.response){
						message.error(`${error.response.data.message}`);
					}
						
					
	
					if(error.code == 'ECONNABORTED' || error.code == 'ERR_NETWORK') {
						message.config({
							duration : 5,
							maxCount : 1,
						});
						message.open({
							type: 'error',
							content:  `${langdata && langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication ? langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication :'It seems the network is unreachable. Please refresh the application.'}`,
						});
					}
				});
		}

	};



	const infoContent = (
		<div style={{
			height: '80vh',
			overflowY: 'auto',
			overflowX: 'auto'
		}}>
			{/* FIRST CARD */}
			<Card size="small" bordered={false} type="inner" style={{ width: 550 }}>
				<p>
					{langdata?.eventbatchverifierinfocontent || 'This module verifies events and alarms using the provided data samples along with the specified time parameters. Verification can be performed in two ways: directly through the dashboard or via a cURL request. Each event is validated against the corresponding models, and the processed results are returned. Events requiring verification can be submitted using the provided cURL format. The verified results will be sent to the specified webhook URL in the defined payload format, or they can be viewed directly through the dashboard.'}
				</p>
			</Card>

			<Space />

			{/* POST CARD */}
			<Card>
				<b>{langdata?.eventVerificationCurl || 'Event Verification cURL'}</b>
				<Card size="small" bordered={true} type="inner" style={{ width: 500, backgroundColor: '#f5f5f5' }}>
					<pre
						style={{
							background: '#f5f5f5',
							padding: 12,
							borderRadius: 6,
							overflowX: 'auto',
							overflowY: 'auto',
							maxHeight: '400px',
							fontSize: 13
						}}
					>
						{`curl --location '${api}/eventverifierbatch'
--header 'accept: application/json'
--header 'apikey: YOUR API KEY'
--form 'file=@"/path/to/your/file.h5"'
--form 'name="Test Batch v1"'
--form 'channelinfoId="2"'
--form 'pidsinfoId="1"'
--form 'startDatetime="2026-04-17T10:22:38.500Z"'
--form 'endDatetime="2026-04-17T10:22:50.900Z"'
--form 'status="New"'
--form 'fiberMetric="Index"'
--form 'analysisType="Event"'
--form 'pipelineId="1"'
--form 'timeWindow="10"'
--form 'sampleSec="2000"'
--form 'webhookUrl=""'
--form 'isdataUploaded="false"'
--form 'binSize="0"'
--form 'startPos="0"'
--form 'amplitudeNumber="0"'
--form 'batchEnded="true"'
--form 'eventPositionarray="[\\"1\\",\\"2\\",\\"3\\"]"'
--form 'referenceeventarray="[\\"Machine Digging\\",\\"Manual Digging\\",\\"Elephant Movement\\"]"'
--form 'referenceEventIdarray="[\\"1\\",\\"2\\",\\"3\\"]"'`}
					</pre>

					{/* FOOTER */}
					<div style={{ borderTop: '1px solid #f0f0f0', marginTop: 10, paddingTop: 8 }}>
						<Button
							size="small"
							onClick={() => {
								const text = [
									`curl --location '${api}/eventverifierbatch'`,
									'--header \'accept: application/json\'',
									'--header \'apikey: YOUR API KEY\'',
									'--form \'file=@"/path/to/your/file.h5"\'',
									'--form \'name="Test Batch v1"\'',
									'--form \'channelinfoId="2"\'',
									'--form \'pidsinfoId="1"\'',
									'--form \'startDatetime="2026-04-17T10:22:38.500Z"\'',
									'--form \'endDatetime="2026-04-17T10:22:50.900Z"\'',
									'--form \'status="New"\'',
									'--form \'fiberMetric="Index"\'',
									'--form \'analysisType="Event"\'',
									'--form \'pipelineId="1"\'',
									'--form \'timeWindow="10"\'',
									'--form \'sampleSec="2000"\'',
									'--form \'webhookUrl=""\'',
									'--form \'isdataUploaded="false"\'',
									'--form \'binSize="0"\'',
									'--form \'startPos="0"\'',
									'--form \'amplitudeNumber="0"\'',
									'--form \'batchEnded="true"\'',
									'--form \'eventPositionarray="[\\"1\\",\\"2\\",\\"3\\"]"\'',
									'--form \'referenceeventarray="[\\"Machine Digging\\",\\"Manual Digging\\",\\"Elephant Movement\\"]"\'',
									'--form \'referenceEventIdarray="[\\"1\\",\\"2\\",\\"3\\"]"\'',
								].join(' \\\n');

								navigator.clipboard.writeText(text);
								notification.open({
									message: langdata?.Copied || 'Copied to clipboard',
									duration: 1
								});
							}}
						>
							{langdata?.CopyToClipboard || 'Copy'}
						</Button>
					</div>
				</Card>
			</Card>

			{/* GET RESPONSE CARD */}
			<Card>
				<b>{langdata?.dataResponseFormat|| 'Data Response Format'}</b>
				<Card size="small" bordered={true} type="inner" style={{ width: 500, backgroundColor: '#f5f5f5' }}>
					<pre
						style={{
							background: '#f5f5f5',
							padding: 12,
							borderRadius: 6,
							overflowX: 'auto',
							overflowY: 'auto',
							maxHeight: '400px',
							fontSize: 13
						}}
					>
						{`[
  {
    "id": 268,
    "name": "Test Batch v1",
    "channelinfoId": 2,
    "pidsinfoId": 1,
    "startDatetime": "2026-04-17T10:22:38.500Z",
    "endDatetime": "2026-04-17T10:22:39.900Z",
    "status": "New",
    "fiberMetric": "Index",
    "analysisType": "Event",
    "createdAt": "2026-04-24T08:35:04.397Z",
    "updatedAt": "2026-04-24T08:35:04.397Z",
    "pipelineId": 1,
    "timeWindow": 10,
    "sampleSec": 2000,
    "webhookUrl": "",
    "send": false,
    "isdataUploaded": true,
    "dataPath": "rawuploads/1777019704399-airline.xls",
    "binSize": 0,
    "startPos": 0,
    "amplitudeNumber": 0,
    "batchEnded": true,
    "channelinfo": { "id": 2, "name": "Pids1 to Ch2", "channelId": 2 },
    "pidsinfo": { "id": 1, "name": "Pids1", "channelId": [1, 2] },
    "eventverifier": [
      { "id": 171, "eventPosition": 1, "referenceevent": "Machine Digging", "referenceEventId": 1, "status": "New" },
      { "id": 172, "eventPosition": 2, "referenceevent": "Manual Digging", "referenceEventId": 2, "status": "New" },
      { "id": 173, "eventPosition": 3, "referenceevent": "Elephant Movement", "referenceEventId": 3, "status": "New" }
    ]
  }
]`}
					</pre>

					{/* FOOTER */}
					<div style={{ borderTop: '1px solid #f0f0f0', marginTop: 10, paddingTop: 8 }}>
						<Button
							size="small"
							onClick={() => {
								const text = `[
  {
    "id": 268,
    "name": "Test Batch v1",
    "channelinfoId": 2,
    "pidsinfoId": 1,
    "startDatetime": "2026-04-17T10:22:38.500Z",
    "endDatetime": "2026-04-17T10:22:39.900Z",
    "status": "New",
    "fiberMetric": "Index",
    "analysisType": "Event",
    "createdAt": "2026-04-24T08:35:04.397Z",
    "updatedAt": "2026-04-24T08:35:04.397Z",
    "pipelineId": 1,
    "timeWindow": 10,
    "sampleSec": 2000,
    "webhookUrl": "",
    "send": false,
    "isdataUploaded": true,
    "dataPath": "rawuploads/1777019704399-airline.xls",
    "binSize": 0,
    "startPos": 0,
    "amplitudeNumber": 0,
    "batchEnded": true,
    "channelinfo": { "id": 2, "name": "Pids1 to Ch2", "channelId": 2 },
    "pidsinfo": { "id": 1, "name": "Pids1", "channelId": [1, 2] },
    "eventverifier": [
      { "id": 171, "eventPosition": 1, "referenceevent": "Machine Digging", "referenceEventId": 1, "status": "New" },
      { "id": 172, "eventPosition": 2, "referenceevent": "Manual Digging", "referenceEventId": 2, "status": "New" },
      { "id": 173, "eventPosition": 3, "referenceevent": "Elephant Movement", "referenceEventId": 3, "status": "New" }
    ]
  }
]`;

								navigator.clipboard.writeText(text);
								notification.open({
									message: langdata?.Copied || 'Copied to clipboard',
									duration: 1
								});
							}}
						>
							{langdata?.CopyToClipboard || 'Copy'}
						</Button>
					</div>
				</Card>
			</Card>

		</div>
	);
	const showAddDrawer = () => {

		setOpenAddDrawer(true);
	};

	const onCloseAddDrawer = () => {
		form.resetFields();
		addBatch.resetForm();
		setOpenAddDrawer(false);
		setFilter({...reportFilter,pidsinfoId:null,channelinfoId:null});
		setfibermetric(null);
		
	};

	const showEditDrawer = (record) => {
		setOpenEditDrawer(true);
		loadBatchDetials(record);
		// getChannels(authtoken,record.pidsinfoId);
	};

	const openDeleteAssetsModal = (record) => {
		setShowDeleteBatchModal(true);
		loadBatchDetials(record);
	};

	const addBatch = useFormik({
		enableReinitialize: true,
		initialValues: {
			name:  '',
			pidsinfoId: null,
			channelinfoId: null,
			startDatetime: null,
			endDatetime: null,
			fiberMetric:'Index',
			analysisType: 'Event',
			eventPosition:[],
			referenceevent:[],
			referenceEventId:[],
			timeWindow:0,
			sampleSec:0,
			webhookUrl:'',
			isdataUploaded :false,
			dataPath : '',
			binSize: 0,
			startPos: 0,
			amplitudeNumber:0,


	
		},
		onSubmit: (values) => {


			const start = values.startDatetime;
			const end = values.endDatetime;
			const startTime = new Date(start);
			const endTime = new Date(end);
			const diffsecs = (new Date(end) - new Date(start))/1000;
			

			
			if (endTime < startTime) {
				Modal.warning({
					title: langdata && langdata.endwarning ? langdata.endwarning : 'End time cannot be earlier than start time'
				});
				return;
			}
			if (!values.name || values.name == null || values.name === '') {
				Modal.warning({ title: langdata && langdata.Pleaseenterthename ? langdata.Pleaseenterthename : 'Please enter the name.' });
				return false;
			}
			if (!values.pidsinfoId || values.pidsinfoId == null || values.pidsinfoId === '') {
				Modal.warning({ title: langdata && langdata.Pleaseenterpidsname ? langdata.Pleaseenterpidsname : 'Please enter pids name' });
				return false;
			}
			if (!values.channelinfoId || values.channelinfoId == null || values.channelinfoId === '') {
				Modal.warning({ title: langdata && langdata.Pleaseenterchannel ? langdata.Pleaseenterchannel : 'Please enter channel' });
				return false;
			}
			if (!values.startDatetime || values.startDatetime == null || values.startDatetime === '') {
				Modal.warning({ title: langdata && langdata.pleaseselectstartdatetime ? langdata.pleaseselectstartdatetime : 'please select start date time' });
				return false;
			}
			if (!values.endDatetime || values.endDatetime == null || values.endDatetime === '') {
				Modal.warning({ title: langdata && langdata.pleaseselectenddatetime ? langdata.pleaseselectenddatetime : 'please select end date time' });
				return false;
			}
			if (diffsecs < 10) {
				Modal.warning({ title: langdata && langdata.thetimegap ? langdata.thetimegap : 'The time gap should atleast 10(secs)' });
				return false;
			}
			
			if (!values.eventPosition || values.eventPosition.length === 0) { 
				Modal.warning({
					title: langdata && langdata.pleaseentereventposition ?  langdata.pleaseentereventposition : 'Please enter event position'
				});
				return;
			}

			if (!values.referenceevent || values.referenceevent.length === 0) {
				Modal.warning({
					title: langdata && langdata.pleaseSelectreferenceevent ?  langdata.pleaseSelectreferenceevent : 'Please select reference event'
				});
				return;
			}

			if (
				values.eventPosition.length !== values.referenceevent.length || values.referenceevent.length !== values.referenceEventId.length
			) {
				Modal.warning({
					title: langdata && langdata.Allfieldsmusthaveequalnumberofentries ?  langdata.Allfieldsmusthaveequalnumberofentries : 'Event Position, Reference Event, and Reference Event ID must have the same number of entries. Please check and correct the inputs.'
				});
				return;
			}

			formDataRef.current = new FormData();

			formDataRef.current.append('name', values.name);
			formDataRef.current.append('pidsinfoId', parseInt(values.pidsinfoId));
			formDataRef.current.append('channelinfoId', parseInt(values.channelinfoId));
			formDataRef.current.append('startDatetime', values.startDatetime);
			formDataRef.current.append('endDatetime', values.endDatetime);
			formDataRef.current.append('fiberMetric', values.fiberMetric);
			formDataRef.current.append('analysisType', values.analysisType);
			formDataRef.current.append('pipelineId', parseInt(pipelineId));
			formDataRef.current.append('eventPositionarray', JSON.stringify(values.eventPosition));
			formDataRef.current.append('referenceeventarray', JSON.stringify(values.referenceevent));
			formDataRef.current.append('referenceEventIdarray', JSON.stringify(values.referenceEventId));
			formDataRef.current.append('timeWindow', values.timeWindow || 0);
			formDataRef.current.append('sampleSec', values.sampleSec || 0);
			formDataRef.current.append('webhookUrl', values.webhookUrl || '');
			formDataRef.current.append('isdataUploaded', values.isdataUploaded || false);
			formDataRef.current.append('dataPath', values.dataPath || '');
			formDataRef.current.append('binSize', values.binSize || 0);
			formDataRef.current.append('startPos', values.startPos || 0);
			formDataRef.current.append('batchEnded', true);
			formDataRef.current.append('amplitudeNumber', values.AmplitudeNumber || 0);
			formDataRef.current.append('file',fileref.current);
			fileref.current = null; //clearing the fileref to prevent duplication

			const isdataUploaded = formDataRef.current.get('isdataUploaded');
			const file = formDataRef.current.get('file');

			if (isdataUploaded === 'true' && (!file && !data.details.dataPath)) {
				Modal.warning({ 
					title: langdata?.PleaseUploadfile ?? 'Please Upload file' 
				});
				return false;}

			dispatch({type:ADD_BATCH});
			let config = {
				method: 'post',
				maxBodyLength: Infinity,
				url: `${api}/eventverifierbatch`,
				timeout: timeout,
				headers: {
					'apikey':`${auth_TOKEN}`
				},
				data:formDataRef.current
			};

	
			axios
				.request(config)	
				.then((response) => {
						
	
					if (response.status === 200 || response.status === 201) {
	
		
						dispatch( { type: ADD_BATCH_SUCCESS, payload: response.data.data });
	
						Modal.success({ title: `${langdata && langdata.AddBatchSuccessfull ? langdata.AddBatchSuccessfull :'Batch Added Successfully'}` });
						loadEventBatch(1);
						form.resetFields();
						addBatch.resetForm();
						setOpenAddDrawer(false);
						formDataRef.current = new FormData();
	
						
					}
				})
				.catch((error) => {
					if(error.response){
						message.error(`${error.response.data.message}`);
					}
						
					dispatch({ type: ADD_BATCH_ERROR});
					if(error.code == 'ECONNABORTED' || error.code == 'ERR_NETWORK') {
						message.config({
							duration : 5,
							maxCount : 1,
						});
						message.open({
							type: 'error',
							content:  `${langdata && langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication ? langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication :'It seems the network is unreachable. Please refresh the application.'}`,
						});
					}

				});

		

			dispatch({ type : EVENT_BATCH_LIST});
	
		}
	});

	const editBatch = useFormik({
		enableReinitialize: true,
		initialValues: {
			name:  data?.details?.name || '',
			pidsinfoId : data?.details?.pidsinfoId ? data?.details?.pidsinfoId : null,
			channelinfoId: data?.details?.channelinfoId ? data?.details?.channelinfoId : null,
			startDatetime: data?.details?.startDatetime ? data?.details?.startDatetime : null,
			endDatetime: data?.details?.endDatetime ? data?.details?.endDatetime : null,
			fiberMetric: data?.details?.fiberMetric ? data?.details?.fiberMetric :'Index',
			analysisType: data?.details?.analysisType ? data?.details?.analysisType :'Event',
			timeWindow: data?.details?.timeWindow ? data?.details?.timeWindow: 0 ,
			sampleSec: data?.details?.sampleSec ? data?.details?.sampleSec: 0 ,
			webhookUrl : data?.details?.webhookUrl ? data?.details?.webhookUrl : '' ,
			isdataUploaded : data?.details?.isdataUploaded ? data?.details?.isdataUploaded :false,
			dataPath : data?.details?.dataPath ? data?.details?.dataPath : '',
			binSize: data?.details?.binSize ? data?.details?.binSize : 0,
			startPos: data?.details?.startPos ? data?.details?.startPos :0,
			amplitudeNumber: data?.details?.amplitudeNumber ? data?.details?.amplitudeNumber :0,

		},
		onSubmit: (values) => {

			const start = values.startDatetime;
			const end = values.endDatetime;
			const startTime = new Date(start);
			const endTime = new Date(end);

			if (!values.name || values.name == null || values.name === '') {
				Modal.warning({ title: langdata && langdata.Pleaseenterthename ? langdata.Pleaseenterthename : 'Please enter the name.' });
				return false;
			}

			if (!values.channelinfoId || values.channelinfoId == null || values.channelinfoId === '') {
				Modal.warning({ title: langdata && langdata.Pleaseenterchannel ? langdata.Pleaseenterchannel : 'Please enter channel' });
				return false;
			}
			
			if (endTime < startTime) {
				Modal.warning({
					title: langdata && langdata.endwarning ? langdata.endwarning : 'End time cannot be earlier than start time'
				});
				return;
			}
			const diffsecs = (endTime - startTime)/1000;

			if (diffsecs < 10) {
				Modal.warning({ title: langdata && langdata.thetimegap ? langdata.thetimegap : 'The time gap should atleast 10(secs)' });
				return false;
			}
			formDataRef.current = new FormData();

			formDataRef.current.append('name', values.name);
			formDataRef.current.append('pidsinfoId', parseInt(values.pidsinfoId));
			formDataRef.current.append('channelinfoId', parseInt(values.channelinfoId));
			formDataRef.current.append('startDatetime', values.startDatetime);
			formDataRef.current.append('endDatetime', values.endDatetime);
			formDataRef.current.append('fiberMetric', values.fiberMetric);
			formDataRef.current.append('analysisType', values.analysisType);
			formDataRef.current.append('pipelineId', parseInt(pipelineId));
			formDataRef.current.append('timeWindow', values.timeWindow || 0);
			formDataRef.current.append('sampleSec', values.sampleSec || 0);
			formDataRef.current.append('webhookUrl', values.webhookUrl || '');
			formDataRef.current.append('isdataUploaded', values.isdataUploaded || false);
			formDataRef.current.append('binSize', values.binSize || 0);
			formDataRef.current.append('startPos', values.startPos || 0);
			formDataRef.current.append('batchEnded', true);
			formDataRef.current.append('amplitudeNumber', values.amplitudeNumber || 0);
			if(fileref.current){
				formDataRef.current.append('file',fileref.current);
				fileref.current = null;
			
			}else{
				formDataRef.current.append('dataPath', data?.details?.dataPath);
			}
			
			const isdataUploaded = formDataRef.current.get('isdataUploaded');
			const file = formDataRef.current.get('file');
			
			
			if (isdataUploaded === 'true' && (!file && !data.details.dataPath)) {
				Modal.warning({ 
					title: langdata?.PleaseUploadfile ?? 'Please Upload file' 
				});
				return false;}
			

			
			dispatch({type:EDIT_BATCH});
			let config = {
				method: 'patch',
				maxBodyLength: Infinity,
				url: `${api}/eventverifierbatch/${data?.details?.id}`,
				timeout: timeout,
				headers: {
					'apikey':`${auth_TOKEN}`
				},
				data: formDataRef.current
			};
 
			axios
				.request(config)
				.then((response) => {
					if (response.status === 200) {
						dispatch( { type: EDIT_BATCH_SUCCESS});
						Modal.success({ title: `${langdata && langdata.BatchUpdatedSuccessfully ? langdata.BatchUpdatedSuccessfully :'Batch Updated Successfully'}` });
						editBatch.resetForm();
						form.resetFields();
						setOpenEditDrawer(false);
						loadEventBatch(1);
						formDataRef.current = new FormData();
					}
				})
				.catch((error) => {
					console.log(error);
					if(error.response){
						
						message.error(`${error.response.data.message}`);
						
					}
						
					dispatch({ type: EDIT_BATCH_ERROR});
					if(error.code == 'ECONNABORTED' || error.code == 'ERR_NETWORK') {
						message.config({
							duration : 5,
							maxCount : 1,
						});
						message.open({
							type: 'error',
							content:  `${langdata && langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication ? langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication :'It seems the network is unreachable. Please refresh the application.'}`,
						});
					}
				});
	
		}
		
	});

	const loadBatchDetials = ((record) => {
		
		dispatch( { type: BATCH_DETAILS });
			
		if (!record) {
			dispatch({ type: BATCH_DETAILS_ERROR });
		} else {
			dispatch({ type: BATCH_DETAILS_SUCCESS, payload: record });
		
		}
		
	});

	const handleModalCancel = () => {
		form.resetFields();
		editBatch.resetForm();
		setOpenEditDrawer(false);
		setfibermetric(null);

	};
	const closeDeleteBatchModal = () => {
		setShowDeleteBatchModal(false);
		setfibermetric(null);
	};

	const deleteBatch = () => {
		const id = parseInt(data?.details?.id);
			
		dispatch({ type: DELETE_BATCH });
		
		let config = {
			method: 'delete',
			maxBodyLength: Infinity,
			url: `${api}/eventverifierbatch/${id}`,
			timeout: timeout,
			headers: {
				accept: 'application/json',
				'Content-Type': 'application/json',
				'apikey':`${auth_TOKEN}`
			}
		};
		
		axios
			.request(config)
			.then((response) => {
				if (response.status === 200) {
					dispatch({type: DELETE_BATCH_SUCCESS, payload: response});
					setShowDeleteBatchModal(false);        
					loadEventBatch(1);
				} else {
					dispatch({type:DELETE_BATCH_ERROR});  
				}
			})
			.catch((error) => {
				dispatch({type:DELETE_BATCH_ERROR});
				if(error.response){
					message.error(`${error.response.data.message}`);
				}
				if(error.code == 'ECONNABORTED' || error.code == 'ERR_NETWORK') {
					message.config({
						duration : 5,
						maxCount : 1,
					});
					message.open({
						type: 'error',
						content: langdata && langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication ? langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication :  'It seems the network is unreachable. Please refresh the application.',
					});
				}
			});
	};
	


	const handleAddFormValuesChange = (changedValues)=>{
		const key = Object.keys(changedValues)[0];
		const val = changedValues[key].target.value;
		if(key ==='PIDS'){
			setFilter({...reportFilter,pidsinfoId:val, channelId : 'all'});
			addBatch.setFieldValue('pidsinfoId', val);
			addBatch.setFieldValue('channelinfoId', null);
			form.setFieldValue('channelinfoId', null);
		}

		if(key==='channelinfoId'){
			setFilter({...reportFilter,channelId:val});
			addBatch.setFieldValue('channelinfoId', val);
		}
	};

	const dateTimeFromHandler = (date,options) =>{
		const isodate = date && date.$d.toISOString();
		if(options =='add'){
			addBatch.setFieldValue('startDatetime', isodate);
		}else if(options =='edit'){
			editBatch.setFieldValue('startDatetime', isodate);
		}
	};


	const dateTimeToHandler = (date,options)=>{
		const isodate = date && date.$d.toISOString();
		if(options=='add'){
			addBatch.setFieldValue('endDatetime', isodate);

		}else if(options =='edit'){

			editBatch.setFieldValue('endDatetime', isodate);
		}
	};


	const handleeventposition =(e)=>{
		const eventpositionarr = e.target.value.split(',');
		addBatch.setFieldValue('eventPosition',eventpositionarr);

	};


	const handlereferenceevent =(e)=>{
		const optarray = e.target.value.split(',');
		addBatch.setFieldValue('referenceevent',optarray);
		// addBatch.setFieldValue('referenceEventId',value);
	};


	const handlereferenceEventId =(e)=>{
		const referenceIdarr = e.target.value;
		const data = referenceIdarr.split(',');

		const invalid = data.some(
			(v) => v.trim() && !Number.isInteger(Number(v))
		);
		if (invalid) {
			Modal.warning({
				title: langdata && langdata.pleaseenterintegers ?  langdata.pleaseenterintegers :'Please enter only integer values'
			});
			return;
		}
		const cleaned = data
			.filter(v => v.trim() !== '')
			.map(v => Number(v));
		addBatch.setFieldValue('referenceEventId',cleaned);

	};


	const handleupdateFormValuesChange = (changedValues)=>{
		const key = Object.keys(changedValues)[0];
		const val = changedValues[key].target.value;
		if(key ==='PIDS'){
			// getChannels(authtoken,val);
			setFilter({...reportFilter,pidsinfoId:val, channelId : 'all'});
			editBatch.setFieldValue('pidsinfoId', val);
			editBatch.setFieldValue('channelinfoId', null);
			form.setFieldValue('channelinfoId', null);
		}

		if(key==='channelinfoId'){
			setFilter({...reportFilter,channelId:val});
			editBatch.setFieldValue('channelinfoId', val);
		}
	};

	const tokensetter = (token)=>{
		setToken(token);
	};

	const submitclick = async () => {
		if (!token) {
			message.error('Invalid Token');
			return;
		}

		try {
			let config = {
				method: 'get',
				url: `${api}/eventverifierbatch?pipelineId=${pipelineId}&$sort[id]=-1`,
				timeout: timeout,
				headers: {
					'apikey': token  
				},
			};

			const response = await axios.request(config);

			if (response.status === 200) {
			
				sessionStorage.setItem('API_TOKEN', token);
				setIsTokenModalOpen(false);
				loadEventBatch(1);
			} else {
				message.error('Invalid Token');
			}
		} catch (error) {
			message.error('Invalid Token');
		}
	};

	if(!auth_TOKEN){
		return(
			<>
			
				<Content
					className="container-login100"
				>
					<Row
						gutter={{
							xs: 8,
							sm: 16,
							md: 24,
							lg: 32
						}}
					>
						{/* Left Space */}
						<Col span={6}>&nbsp;</Col>

						{/* Center Content */}
						<Col
							span={12}
							style={{
								display: 'flex',
								justifyContent: 'center',
								alignItems: 'center'
							}}
						>
							<Row
								style={{
									display: 'flex',
									justifyContent: 'center',
									alignItems: 'center',
									width: '100%'
								}}
							>
								{/* Logo */}
								<Col
									span={24}
									style={{
										display: 'flex',
										justifyContent: 'center',
										alignItems: 'center',
										marginBottom: '10px'
									}}
								>
									<img
										src={logo}
										alt="Logo"
										style={{
											width: 'auto',
											height: '60px',
										}}
									/>
								</Col>

								{/* Modal-like Token Box */}
								<Col span={24}
									style={{
										display: 'flex',
										justifyContent: 'center',
										alignItems: 'center',
										marginBottom: '10px'
									}}>
									<Card
										title={
											langdata?.enterAccessToken || 'Enter Access Token'
										}
										bordered={false}
										style={{
											width: '600px',
											textAlign: 'center',
											padding: '20px'
										}}
									>
										<Input.Password
											placeholder="Enter your token"
											onChange={(e) => tokensetter(e.target.value)}
											onPressEnter={submitclick}
										/>

										<Button
											type="primary"
											style={{
												marginTop: '20px',
												width: '100%',

											}}
											onClick={submitclick}
										>
							Submit
										</Button>
									</Card>
								</Col>
							</Row>
						</Col>

						{/* Right Space */}
						<Col span={6}>&nbsp;</Col>
					</Row>
				</Content>
			
				
			</>
		);
	}

	const dataenableToggle = (value,options)=>{
		
		if(options === 'add'){
			addBatch.setFieldValue('isdataUploaded',value);
			addBatch.setFieldValue('timeWindow',0);
			addBatch.setFieldValue('sampleSec',0);
			addBatch.setFieldValue('binSize',0);
			addBatch.setFieldValue('startPos',0);
			addBatch.setFieldValue('amplitudeNumber',0);
			
			form.setFieldValue({
				binSize: 0,
				startPos: 0,
				timeWindow: 0,
				sampleSec: 0,
				amplitudeNumber: 0,
				dataPath: ''
			});
			fileref.current = null;

		}
		if(options === 'edit'){
			editBatch.setFieldValue('dataPath','');
			editBatch.setFieldValue('isdataUploaded',value);
			editBatch.setFieldValue('timeWindow',0);
			editBatch.setFieldValue('sampleSec',0);
			editBatch.setFieldValue('binSize',0);
			editBatch.setFieldValue('startPos',0);
			editBatch.setFieldValue('amplitudeNumber',0);
			form.setFieldValue({
				binSize: 0,
				startPos: 0,
				timeWindow: 0,
				sampleSec: 0,
				amplitudeNumber: 0,
				dataPath: ''
			});
			fileref.current = null;

		}
	};

	const fibermetrichandler = (value,options,text) =>{
		
		if(text === 'add'){
			addBatch.setFieldValue('fiberMetric',value);
			setfibermetric(options.label);


		}

		if(text === 'edit'){
			editBatch.setFieldValue('fiberMetric',value);
			setfibermetric(options.label);
		}
	};


	const handlenamesearch = (e) => {
		setNameSearch(e.target.value);
	};
	const handleActivitysearch = (e) => {
		setactivitySearch(e);
	};

	const onRangeChange = (dates) => {
		if (dates) {
			if(settingstimeformat.includes(':ss')){
				const isoStartDate = dates && dates[0].$d;
				const isoEndDate = dates && dates[1].$d;
				setStartDate(isoStartDate);
				setEndDate(isoEndDate);
	
			}else{
					
				const isoStartDate = moment.utc(dates && dates[0].$d).second(0);
				const isoEndDate = moment.utc(dates && dates[1].$d).second(59);
				setStartDate(isoStartDate);
				setEndDate(isoEndDate);
	
			}
		} else {
			console.log('Clear');
		}
	};
		
	const disabledDate = (current) => {
		// Can not select days before today and today
		return current && current > dayjs().endOf('day');
	};
	
	const getDateWithTime = (date, time) => {
		if (!time) return date;
		const [hour, minute, second] = time.split(':').map(Number);
		return dayjs(date)
			.set('hour', hour)
			.set('minute', minute)
			.set('second', second);
	};
	


    
	return (
		
		<>
			<Content style={{
				background: '#F5F5F5',
				minHeight: '100vh',   
				padding: '10px',      
			}}>
				
				<Row 
					style={{
						margin: '10px',
						paddingLeft: '10px',
						paddingRight: '10px',
						background: '#FFFFFF',
						alignItems:'center'
					}} >

					<Col span={8}>
						<Row>

							<Space>
								<UnorderedListOutlined style={{fontSize:'30px'}}/>
							</Space>
							<Space>&nbsp;&nbsp;</Space>
					
							<Title level={4} style={{ paddingTop:'10px'}}>{langdata && langdata && langdata.EventVerifierBatch ? langdata.EventVerifierBatch : 'Event Verifier Batch'}</Title>
						</Row>
					</Col>
					<Col span={16}>
						<Row justify="end">
							<Col>
								<Space>
									<Tooltip placement="bottom" title={langdata && langdata.Searchbyname ? langdata.Searchbyname : 'Search by Name'}>
										<Space>
											{/* <Search
									style={{ minWidth: '240px', margin : '5px'}}
									showSearch
									placeholder="Search by name"
									onSearch={handleUserSearch}
								/> */}
											<Search
												style={{margin:'5px', verticalAlign:'middle', marginTop:'2px', paddingRight:'10px'}}
												showSearch
												placeholder={langdata && langdata.Searchbyname ? langdata.Searchbyname : 'Search by Name'}
												onChange={handlenamesearch}
												enterButton
											/>
										</Space>
									</Tooltip>
								</Space>
								<Space>
									<Tooltip placement="bottom" title={langdata && langdata.SearchbyConfirmedActivity ? langdata.SearchbyConfirmedActivity : 'Search by Confirmed Activity'}>
										<Space>
											<Search
												style={{margin:'5px', verticalAlign:'middle', marginTop:'2px', paddingRight:'10px'}}
												showSearch
												placeholder={langdata && langdata.SearchbyConfirmedActivity ? langdata.SearchbyConfirmedActivity : 'Search by Confirmed Activity'}
												onSearch={handleActivitysearch}
												enterButton
											/>
										</Space>
									</Tooltip>
								</Space>
								<Space>
									<Tooltip title={langdata?.Selectdate || 'Select date'}>
										<RangePicker
											style={{margin:'5px',maxWidth:'340px'}}
											onChange={onRangeChange}
											disabledDate={disabledDate}
											allowClear={false}
											showTime
											format={`${settingsdateformat} ${settingstimeformat}`}
											defaultValue={[
												getDateWithTime(dayjs().subtract(30, 'day'), customstart),
												getDateWithTime(dayjs(), customend)
											]}
										/>
									</Tooltip>
								</Space>
								<Space>
									<Button style={{margin:'5px'}} type="primary" onClick={showAddDrawer}><PlusOutlined/>{langdata && langdata.AddNew ? langdata.AddNew : 'Add New'}</Button>
								</Space>
		
								<Space>&nbsp;</Space>
								<Space>
									<Typography>
										<Popover title={langdata && langdata.EventVerifierBatch ? langdata.EventVerifierBatch:'Event Verifier Batch'}  content={infoContent} trigger="click">
											<Avatar size="small"><InfoOutlined /></Avatar>
										</Popover>
									</Typography>
								</Space>
							</Col>
						</Row>
					</Col>
				</Row>
				
				<Row span={24} style={{
					margin: '10px',
					paddingLeft: '10px',
					paddingRight: '10px',
					marginTop:'0px',
					background: '#FFFFFF',
					alignItems:'center'
				}}>
					<Col span={24}>
						{data?.batch?.length > 0 ?
							<Table 
								scroll={{
									x: 900,
								}}
								pagination = { data.batch.length > 0 ? data.pagination : 0 }
								columns={columns} dataSource={data.batch} 
								onChange = { loadEventBatch }

								
								
							/>
							:
							<Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
						}
					</Col>
				</Row>

				<Modal
					title={ langdata&&langdata.AddBatch ? langdata.AddBatch : 'Add Batch' }
					centered
					destroyOnClose={true}
					maskClosable={false}
					open={openAddDrawer}
					onOk={{onCloseAddDrawer}}
					onCancel={onCloseAddDrawer}
					footer={[
						// eslint-disable-next-line react/jsx-key
						<Space>
							<Button onClick={onCloseAddDrawer}>{langdata && langdata.CLOSE ? langdata.CLOSE : 'CLOSE' }</Button>
							{<Button type="primary" onClick={addBatch.handleSubmit}>{langdata && langdata.SAVE ? langdata.SAVE : 'SAVE' }</Button> }
						</Space>
					]}
					width={800}
				>
					<Form layout="vertical" onSubmit={addBatch.handleSubmit} form={form} >
									
						<Row gutter={24}>
							<Col span={24}>
								<Form.Item name="name" label={langdata&&langdata.Name?langdata.Name:'Name'} rules={[{ required: true, message: langdata && langdata.PleaseEnterName ? langdata.PleaseEnterName : 'Please Enter Name' }]} >
									<Input name="name" onChange={addBatch.handleChange} placeholder={langdata&&langdata.PleaseEnterName?langdata.PleaseEnterName:'Please Enter Name'} />
								</Form.Item>
							</Col>
						</Row>	

						<Row gutter={24}>
							<Col span={24}>
								<Form.Item name="PIDS" label={ langdata&&langdata.PIDS?langdata.PIDS:'PIDS'} rules={[{ required: true, message: langdata && langdata.SelectPIDS ? langdata.SelectPIDS :'Select PIDS'}]} >
									<Input name="PIDS" 
										onChange={(value)=>{handleAddFormValuesChange({'PIDS': value});}} 
										placeholder={langdata && langdata.SelectPIDS ? langdata.SelectPIDS :'Select PIDS'}
									/>


								</Form.Item>
							</Col>
						</Row>
						<Row gutter={24}>
							<Col span={24}>
								<Form.Item name="channelinfoId" label={ langdata&&langdata.channelName?langdata.channelName:'channel Name'} rules={[{ required: true, message: langdata && langdata.PleaseEnterChannelName ? langdata.PleaseEnterChannelName :'PleaseEnterChannelName'}]} >
									<Input name="channelinfoId" 
										onChange={(value)=>{handleAddFormValuesChange({'channelinfoId': value});}}
										placeholder={langdata && langdata.PleaseEnterChannelName ? langdata.PleaseEnterChannelName :'Please Enter Channel Name'}
									/>

								</Form.Item>
							</Col>
						</Row>


						<Row gutter={24}>
							<Col span={24}>
								<Form.Item label={langdata && langdata.StartDate ? langdata.StartDate:'Start Date'}  required rules={[{ required: true, message: `${langdata && langdata.pleaseselectstartdatetime ? langdata.pleaseselectstartdatetime : 'please select start date time'}` }]}>
									<DatePicker  style={{ width: '100%'}} allowClear={false}  
										// value={formik.values.datetimeFrom}
										placeholder={langdata && langdata.pleaseselectstartdatetime ? langdata.pleaseselectstartdatetime : 'please select start date time'}
										onChange={(date)=>{dateTimeFromHandler(date,'add');}} 
										format = {settingsdateformat  + ' ' + settingstimeformat}	
										showTime/>
								</Form.Item>
							</Col>
						</Row>
						<Row gutter={24}>
							<Col span={24}>
								<Form.Item label={langdata && langdata.EndDate ? langdata.EndDate:'End Date'}  required rules={[{ required: true, message: `${langdata && langdata.pleaseselectenddatetime ? langdata.pleaseselectenddatetime : 'please select end date time'}` }]}>
									<DatePicker  style={{ width: '100%'}} allowClear={false}  
										// value={formik.values.datetimeTo}
										placeholder={langdata && langdata.pleaseselectenddatetime ? langdata.pleaseselectenddatetime : 'please select end date time'}
										onChange={(date)=>{ dateTimeToHandler(date,'add');}} format = {settingsdateformat  + ' ' + settingstimeformat} 
										showTime/>
								</Form.Item>
							</Col>
						</Row>

						<Row gutter={24}>
							<Col span={24}>
								<Form.Item name="analysisType" label={ langdata&&langdata.analysisType?langdata.analysisType:'Analysis Type'} rules={[{ required: false, message: langdata && langdata.pleaseselectanalysistype ? langdata.pleaseselectanalysistype :'please select analysis type'}]} >
									<Select Item
										style={{ width : '100%'}}
										name="analysisType"
										showSearch
										filterOption={filterOption}
										placeholder={langdata && langdata.pleaseselectanalysistype ? langdata.pleaseselectanalysistype :'please select analysis type'}
										optionFilterProp="children"	
										onSelect={(value)=>{addBatch.setFieldValue('analysisType',value);}}
										value={addBatch.values.analysisType}
										// onSelect={handleSetChannel}
										options={analysisTypeoptions}
															
									/>
								</Form.Item>
							</Col>
						</Row>
						<Row gutter={24}>
							<Col span={24}>
								<Form.Item name="fiberMetric" label={ langdata&&langdata.fiberMetric?langdata.fiberMetric:'Fiber Metric'} rules={[{ required: false, message: langdata && langdata.Pleaseselectfibermetric ? langdata.Pleaseselectfibermetric :'Please select fiber metric'}]} >
									<Select Item
										style={{ width : '100%'}}
										name="fiberMetric"
										showSearch
										filterOption={filterOption}
										placeholder={langdata && langdata.Pleaseselectfibermetric ? langdata.Pleaseselectfibermetric :'Please select fiber metric'}
										optionFilterProp="children"	
										onSelect={(value,options)=>fibermetrichandler(value,options,'add')}
										value={addBatch.values.fiberMetric}
										// onSelect={handleSetChannel}
										options={fibermetricoptions}
															
									/>
								</Form.Item>
							</Col>
						</Row>

						

						<Row gutter={24}>
							<Col span={24}>
								<Form.Item name="eventPosition" 
									label={fiber && fiber === 'Length' ? langdata&&langdata.Fiberlength?langdata.Fiberlength:'Fiber length' : langdata&&langdata.eventPosition?langdata.eventPosition:'Event Position'  } 
									rules={[{ required: true, message: fiber && fiber === 'Length' ? langdata && langdata.Pleaseenterthefiberlength ? langdata.Pleaseenterthefiberlength :' Please enter  fiber length'   :langdata && langdata.pleaseentereventPosition ? langdata.pleaseentereventPosition : 'please enter event position' }]} >
									<Input name="eventPosition" onChange={(e)=>handleeventposition(e)} 
										placeholder={fiber && fiber === 'Length' ? langdata && langdata.Pleaseenterthefiberlength ? langdata.Pleaseenterthefiberlength :' Please enter  fiber length'   :langdata && langdata.pleaseentereventPosition ? langdata.pleaseentereventPosition : 'please enter event position'} />
								</Form.Item>
							</Col>
						</Row>

						<Row gutter={24}>
							<Col span={24}>
								<Form.Item name='algtag' >
									<Tag name='algtag' style={{
										maxWidth: '100%',
										whiteSpace: 'normal',
										wordBreak: 'break-word',
										lineHeight: '1.9'
									}} color="blue">{fiber && fiber === 'Length' ? langdata&&langdata.Fiberlength?langdata.Fiberlength:'Fiber length' : langdata&&langdata.eventPosition?langdata.eventPosition:'Event Position'  } {'['}{
											<Space wrap>
											1, 2, 3
											</Space>}{']'} </Tag>
								</Form.Item>
							</Col>
						</Row>


						<Row gutter={24}>
							<Col span={24}>
								<Form.Item name="referenceevent" label={ langdata&&langdata.referenceevent?langdata.referenceevent:'Reference event'} rules={[{ required: true, message: langdata && langdata.pleaseselectreferenceevent ? langdata.pleaseselectreferenceevent :'please select reference event'}]} >
									{/* <Select Item
										style={{ width : '100%'}}
										mode="multiple"
										name="referenceevent"
										showSearch
										filterOption={filterOption}
										placeholder={langdata && langdata.pleaseselectreferenceevent ? langdata.pleaseselectreferenceevent :'please select reference event'}
										optionFilterProp="children"	
										onChange={(value,label)=>{handlereferenceevent(value,label);}}
										// value={addBatch.values.referenceevent}
										// onSelect={handleSetChannel}
										options={referenceeventoptions}
															
									/> */
									}
									<Input name="referenceevent" 
										onChange={(e)=>{handlereferenceevent(e);}}
										placeholder={langdata && langdata.pleaseselectreferenceevent ? langdata.pleaseselectreferenceevent :'please select reference event'}
									/>

								</Form.Item>
							</Col>
						</Row>
						<Row gutter={24}>
							<Col span={24}>
								<Form.Item name='algtag' >
									<Tag name='algtag' style={{
										maxWidth: '100%',
										whiteSpace: 'normal',
										wordBreak: 'break-word',
										lineHeight: '1.9'
									}} color="blue">{langdata&&langdata.referenceevent?langdata.referenceevent:'Reference event' } {'['}{
											<Space wrap>
											Machine Digging, Manual Digging, Elephant Movement
											</Space>}{']'} </Tag>
								</Form.Item>
							</Col>
						</Row>
						<Row gutter={24}>
							<Col span={24}>
								<Form.Item name="referenceEventId" label={langdata&&langdata.referenceEventId?langdata.referenceEventId:'Reference Event Id'} rules={[{ required: true, message: langdata && langdata.pleaseenterreferenceeventId ? langdata.pleaseenterreferenceeventId : 'Please enter reference eventId' }]} >
									<Input name="referenceEventId" onChange={(e)=>handlereferenceEventId(e)} 
										placeholder={langdata && langdata && langdata.pleaseenterreferenceeventId ? langdata.pleaseenterreferenceeventId : 'Please enter reference eventId' } />
								</Form.Item>
							</Col>
						</Row>
						<Row gutter={24}>
							<Col span={24}>
								<Form.Item name='algtag' >
									<Tag name='algtag' style={{
										maxWidth: '100%',
										whiteSpace: 'normal',
										wordBreak: 'break-word',
										lineHeight: '1.9'
									}} color="blue">{langdata&&langdata.referenceEventId?langdata.referenceEventId:'Reference Event Id' } {'['}{
											<Space wrap>
											1, 2, 3
											</Space>}{']'} </Tag>
								</Form.Item>
							</Col>
						</Row>

						<Row gutter={24}>
							
							<Col span={10}>
								<Form.Item name="isdataUploaded" label={ langdata&&langdata.dataUpload?langdata.dataUpload:'Data Upload'} rules={[{ required: false}]} >
									<Switch size='small'  onChange={(value) => dataenableToggle(value,'add')} />


								</Form.Item>
							</Col>

							<Col span={14}>
								<Form.Item name="dataPath" label={ langdata&&langdata.dataPath?langdata.dataPath:'Data Path'} rules={[{ required: false}]} >
									<Upload
										maxCount={1}
										beforeUpload={() => false}
										// accept=".csv,.xlsx,.xls"
										onChange={fileUploader}
									>
										<Button  	disabled={addBatch.values.isdataUploaded === false} icon={<UploadOutlined />}>Select File</Button>
									</Upload>


								</Form.Item>
							</Col>
						</Row>

						
						<Row gutter={24}>
							<Col span={24}>
								<Form.Item name="binSize" label={ langdata&&langdata.binSize?langdata.binSize:'Bin Size'} rules={[{ required: false, message: langdata && langdata.PleaseEnterbinSize ? langdata.PleaseEnterbinSize :'Please enter bin size'}]} >
									<InputNumber name="binSize"
										style={{width:'100%'}} 
										min={0}
										step={0.1}
										value={addBatch.values.binSize}
										onChange={(value)=>{addBatch.setFieldValue('binSize',value);}} 
										disabled={addBatch.values.isdataUploaded === false}
										placeholder={ langdata && langdata.PleaseEnterbinSize ? langdata.PleaseEnterbinSize :'Please enter bin size'}
									/>


								</Form.Item>
							</Col>
						</Row>

						<Row gutter={24}>
							<Col span={24}>
								<Form.Item name="startPos"   
									label={`${langdata && langdata.StartPosition ? langdata.StartPosition : 'Start Position'} (${
										fiber && fiber === 'Length'
											? (langdata && langdata.fiberMetric
												? langdata.fiberMetric
												: 'fiber Metric')
											: (langdata && langdata.ODMeter
												? langdata.ODMeter
												: 'ODMeter')
									})`}
									rules={[{ required: false, message: langdata && langdata.Pleaseenterthestartposition ? langdata.Pleaseenterthestartposition :'Please enter the start position'}]} >
									<InputNumber name="startPos"
										style={{width:'100%'}} 
										min={0}
										step={0.1}
										value={addBatch.values.startPos}
										disabled={addBatch.values.isdataUploaded === false}
										onChange={(value)=>{addBatch.setFieldValue('startPos',value);}} 
										placeholder={ langdata && langdata.Pleaseenterthestartposition ? langdata.Pleaseenterthestartposition :'Please enter the start position'}
									/>


								</Form.Item>
							</Col>
						</Row>

						<Row gutter={24}>
							<Col span={24}>
								<Form.Item name="amplitudeNumber" label={ langdata&&langdata.AmplitudeNumber?langdata.AmplitudeNumber:'Amplitude Number'} rules={[{ required: false, message: langdata && langdata.Pleaseenteramplitudenumber ? langdata.Pleaseenteramplitudenumber :'Please enter amplitude number'}]} >
									<InputNumber name="amplitudeNumber"
										style={{width:'100%'}} 
										step={0.1}
										min={0}
										value={addBatch.values.amplitudeNumber}
										disabled={addBatch.values.isdataUploaded === false}
										onChange={(value)=>{addBatch.setFieldValue('amplitudeNumber',value);}} 
										placeholder={langdata&&langdata.AmplitudeNumber?langdata.AmplitudeNumber:'Amplitude Number'}
									/>


								</Form.Item>
							</Col>
						</Row>


						<Row gutter={24}>
							<Col span={24}>
								<Form.Item name="timeWindow" label={ langdata&&langdata.timeWindow?langdata.timeWindow:'Time Window'} rules={[{ required: false, message: langdata && langdata.PleaseEntertimeWindow ? langdata.PleaseEntertimeWindow :'Please Enter Time Window'}]} >
									<InputNumber name="timeWindow"
										style={{width:'100%'}} 
										min={0}
										value={addBatch.values.timeWindow}
										onChange={(value)=>{addBatch.setFieldValue('timeWindow',value);}} 
										disabled={addBatch.values.isdataUploaded === false}
										placeholder={langdata && langdata.PleaseEntertimeWindow ? langdata.PleaseEntertimeWindow :'Please Enter Time Window'}
									/>


								</Form.Item>
							</Col>
						</Row>

						<Row gutter={24}>
							<Col span={24}>
								<Form.Item name="sampleSec" label={ langdata&&langdata.sampleSec?langdata.sampleSec:'sampleSec'} rules={[{ required: false, message: langdata && langdata.PleaseEntersampleSec ? langdata.PleaseEntersampleSec :'Please Enter SampleSec'}]} >
									<InputNumber name="sampleSec" 
										min={0}
										style={{width:'100%'}} 
										value={addBatch.values.sampleSec}
										onChange={(value)=>{addBatch.setFieldValue('sampleSec',value);}} 
										disabled={addBatch.values.isdataUploaded === false}
										placeholder={langdata && langdata.PleaseEntersampleSec ? langdata.PleaseEntersampleSec :'Please Enter SampleSec'}
									/>


								</Form.Item>
							</Col>
						</Row>
						<Row gutter={24}>
							<Col span={24}>
								<Form.Item name="webhookUrl" label={ langdata&&langdata.webhookUrl?langdata.webhookUrl:'webhookUrl'} rules={[{ required: false, message: langdata && langdata.PleaseEnterwebhookUrl ? langdata.PleaseEnterwebhookUrl :'Please Enter webhookUrl'}]} >
									<Input name="webhookUrl" 
										onChange={(e) => {addBatch.setFieldValue('webhookUrl', e.target.value);}}
										placeholder={langdata && langdata.PleaseEnterwebhookUrl ? langdata.PleaseEnterwebhookUrl :'Please Enter webhookUrl'}
									/>


								</Form.Item>
							</Col>
						</Row>

					</Form>
				</Modal>


				<Modal
					title={langdata && langdata.EditBatchDetails ? langdata.EditBatchDetails:'Edit Batch Details'}
					width={800}	
					centered
					destroyOnClose={true}
					maskClosable={false}
					onOk={editBatch.handleSubmit}
					onCancel={handleModalCancel}
					open={openEditDrawer}
					styles={{
						body: {
						},
					}}
					footer={[
						// eslint-disable-next-line react/jsx-key
						<Space>
							<Button onClick={handleModalCancel}>
								{langdata && langdata.CANCEL ? langdata.CANCEL:'CANCEL'}
							</Button>
							<Button onClick={editBatch.handleSubmit} type="primary">
								{langdata && langdata.SAVE ? langdata.SAVE:'SAVE'}
							</Button>
						</Space>
					]}
				>
					<Form onSubmit={editBatch.handleSubmit} layout="vertical"
						form={form} 
						// onValuesChange={handleUpdateFormValuesChange}
					>
						<Row gutter={24}>
							<Col span={24}>
								<Form.Item label={langdata && langdata.Name ? langdata.Name:'Name'} rules={[{ required: true, message: `${langdata && langdata.Name ? langdata.Name:'Name'}` }]}>
									<Input name="name" value={editBatch.values.name} onChange={editBatch.handleChange} defaultValue={editBatch.values.name}   />
								</Form.Item>
							</Col>
						</Row>


						<Row gutter={24}>
							<Col span={24}>
								<Form.Item name="PIDS" label={ langdata&&langdata.PIDS?langdata.PIDS:'PIDS'} rules={[{ required: true, message: langdata && langdata.SelectPIDS ? langdata.SelectPIDS :'Select PIDS'}]} >
									<Input name="PIDS" 
										onChange={(value)=>{handleupdateFormValuesChange({'PIDS': value});}} 
										defaultValue={editBatch.values.pidsinfoId}
										placeholder={langdata && langdata.SelectPIDS ? langdata.SelectPIDS :'Select PIDS'}
									/>


								</Form.Item>
							</Col>
						</Row>
						
						<Row gutter={24}>
							<Col span={24}>
								<Form.Item name="channelinfoId" label={ langdata&&langdata.channelName?langdata.channelName:'channel Name'} rules={[{ required: true, message: langdata && langdata.PleaseEnterChannelName ? langdata.PleaseEnterChannelName :'PleaseEnterChannelName'}]} >
									<Input name="channelinfoId" 
										onChange={(value)=>{handleupdateFormValuesChange({'channelinfoId': value});}}
										placeholder={langdata && langdata.PleaseEnterChannelName ? langdata.PleaseEnterChannelName :'Please Enter Channel Name'}
										defaultValue={editBatch.values.channelinfoId}
									/>

								</Form.Item>
							</Col>
						</Row>


						<Row gutter={24}>
							<Col span={24}>
								<Form.Item label={langdata && langdata.StartDate ? langdata.StartDate:'Start Date'}  required rules={[{ required: true, message: `${langdata && langdata.pleaseselectstartdatetime ? langdata.pleaseselectstartdatetime : 'please select start date time'}` }]}>
									<DatePicker  style={{ width: '100%'}} allowClear={false}  
										// value={formik.values.datetimeFrom}
										placeholder={langdata && langdata.pleaseselectstartdatetime ? langdata.pleaseselectstartdatetime : 'please select start date time'}
										onChange={(date)=>{dateTimeFromHandler(date,'edit');}} 
										format = {settingsdateformat  + ' ' + settingstimeformat}
										value={editBatch.values.startDatetime? dayjs(editBatch.values.startDatetime): null}		
										showTime/>
								</Form.Item>
							</Col>
						</Row>
						<Row gutter={24}>
							<Col span={24}>
								<Form.Item label={langdata && langdata.EndDate ? langdata.EndDate:'End Date'}  required rules={[{ required: true, message: `${langdata && langdata.pleaseselectenddatetime ? langdata.pleaseselectenddatetime : 'please select end date time'}` }]}>
									<DatePicker  style={{ width: '100%'}} allowClear={false}  
										// value={formik.values.datetimeTo}
										placeholder={langdata && langdata.pleaseselectenddatetime ? langdata.pleaseselectenddatetime : 'please select end date time'}
										onChange={(date)=>{ dateTimeToHandler(date,'edit');}} format = {settingsdateformat  + ' ' + settingstimeformat} 
										value={editBatch.values.endDatetime? dayjs(editBatch.values.endDatetime): null}	
										showTime/>
								</Form.Item>
							</Col>
						</Row>

						<Row gutter={24}>
							<Col span={24}>
								<Form.Item name="analysisType" label={ langdata&&langdata.analysisType?langdata.analysisType:'Analysis Type'} rules={[{ required: false, message: langdata && langdata.pleaseselectanalysistype ? langdata.pleaseselectanalysistype :'please select analysis type'}]} >
									<Select Item
										style={{ width : '100%'}}
										name="analysisType"
										showSearch
										filterOption={filterOption}
										placeholder={langdata && langdata.pleaseselectanalysistype ? langdata.pleaseselectanalysistype :'please select analysis type'}
										optionFilterProp="children"	
										onSelect={(value)=>{editBatch.setFieldValue('analysisType',value);}}
										defaultValue={editBatch.values.analysisType}
										
										// onSelect={handleSetChannel}
										options={analysisTypeoptions}
															
									/>
								</Form.Item>
							</Col>
						</Row>
						<Row gutter={24}>
							<Col span={24}>
								<Form.Item name="fiberMetric" label={ langdata&&langdata.fiberMetric?langdata.fiberMetric:'Fiber Metric'} rules={[{ required: false, message: langdata && langdata.Pleaseselectfibermetric ? langdata.Pleaseselectfibermetric :'Please select fiber metric'}]} >
									<Select Item
										style={{ width : '100%'}}
										name="fiberMetric"
										showSearch
										filterOption={filterOption}
										placeholder={langdata && langdata.Pleaseselectfibermetric ? langdata.Pleaseselectfibermetric :'Please select fiber metric'}
										optionFilterProp="children"	
										onSelect={(value,options)=>fibermetrichandler(value,options,'edit')}
										defaultValue={editBatch.values.fiberMetric}
										// onSelect={handleSetChannel}
										options={fibermetricoptions}
															
									/>
								</Form.Item>
							</Col>
						</Row>

						<Row gutter={24}>
							
							<Col span={10}>
								<Form.Item name="isdataUploaded" label={ langdata&&langdata.dataUpload?langdata.dataUpload:'Data Upload'} rules={[{ required: false}]} >
									<Switch  name="isdataUploaded" size='small'  onChange={(value) => dataenableToggle(value,'edit')} 
										defaultValue={editBatch.values.isdataUploaded} />


								</Form.Item>
							</Col>

							<Col span={14}>
								<Form.Item name="dataPath" label={ langdata&&langdata.dataPath?langdata.dataPath:'Data Path'} rules={[{ required: false}]} >
									<Upload
										maxCount={1}
										beforeUpload={() => false}
										onChange={fileUploader}
										
									>
										<Button  disabled={editBatch.values.isdataUploaded === false}icon={<UploadOutlined />}>Select File</Button>
									</Upload>


								</Form.Item>
							</Col>
						</Row>

						
						<Row gutter={24}>
							<Col span={24}>
								<Form.Item  label={ langdata&&langdata.binSize?langdata.binSize:'Bin Size'} rules={[{ required: false, message: langdata && langdata.PleaseEnterbinSize ? langdata.PleaseEnterbinSize :'Please enter bin size'}]} >
									<InputNumber 
										name="binSize" 
										style={{width:'100%'}} 
										min={0}
										step={0.1}
										value={editBatch.values.binSize}
										disabled={editBatch.values.isdataUploaded === false}
										onChange={(value)=>{editBatch.setFieldValue('binSize',value);}} 
										placeholder={ langdata && langdata.PleaseEnterbinSize ? langdata.PleaseEnterbinSize :'Please enter bin size'}
									/>


								</Form.Item>
							</Col>
						</Row>

						<Row gutter={24}>
							<Col span={24}>
								<Form.Item  label={`${langdata && langdata.StartPosition ? langdata.StartPosition : 'Start Position'} (${
									fiber && fiber === 'Length'
										? (langdata && langdata.fiberMetric
											? langdata.fiberMetric
											: 'fiber Metric')
										: (langdata && langdata.ODMeter
											? langdata.ODMeter
											: 'ODMeter')
								})`} rules={[{ required: false, message: langdata && langdata.Pleaseenterthestartposition ? langdata.Pleaseenterthestartposition :'Please enter the start position'}]} >
									<InputNumber name="startPos"
										style={{width:'100%'}} 
										min={0}
										step={0.1}
										value={editBatch.values.startPos}
										disabled={editBatch.values.isdataUploaded === false}
										onChange={(value)=>{editBatch.setFieldValue('startPos',value);}} 
										placeholder={ langdata && langdata.Pleaseenterthestartposition ? langdata.Pleaseenterthestartposition :'Please enter the start position'}
									/>


								</Form.Item>
							</Col>
						</Row>

						<Row gutter={24}>
							<Col span={24}>
								<Form.Item label={ langdata&&langdata.AmplitudeNumber?langdata.AmplitudeNumber:'Amplitude Number'} rules={[{ required: false, message: langdata && langdata.Pleaseenteramplitudenumber ? langdata.Pleaseenteramplitudenumber :'Please enter amplitude number'}]} >
									<InputNumber name="amplitudeNumber"
										style={{width:'100%'}} 
										step={0.1}
										min={0}
										value={editBatch.values.amplitudeNumber}
										disabled={editBatch.values.isdataUploaded === false}
										onChange={(value)=>{editBatch.setFieldValue('amplitudeNumber',value);}} 
										placeholder={langdata&&langdata.AmplitudeNumber?langdata.AmplitudeNumber:'Amplitude Number'}
									/>


								</Form.Item>
							</Col>
						</Row>

						<Row gutter={24}>
							<Col span={24}>
								<Form.Item label={ langdata&&langdata.timeWindow?langdata.timeWindow:'Time Window'} rules={[{ required: false, message: langdata && langdata.PleaseEntertimeWindow ? langdata.PleaseEntertimeWindow :'Please Enter Time Window'}]} >
									<InputNumber name="timeWindow"
										style={{width:'100%'}} 
										min={0}
										value={editBatch.values.timeWindow}
										disabled={editBatch.values.isdataUploaded === false}
										onChange={(value)=>{editBatch.setFieldValue('timeWindow',value);}} 
										placeholder={langdata && langdata.PleaseEntertimeWindow ? langdata.PleaseEntertimeWindow :'Please Enter Time Window'}
									/>


								</Form.Item>
							</Col>
						</Row>

						<Row gutter={24}>
							<Col span={24}>
								<Form.Item label={ langdata&&langdata.sampleSec?langdata.sampleSec:'sampleSec'} rules={[{ required: false, message: langdata && langdata.PleaseEntersampleSec ? langdata.PleaseEntersampleSec :'Please Enter SampleSec'}]} >
									<InputNumber name="sampleSec" 
										min={0}
										value={editBatch.values.sampleSec}
										disabled={editBatch.values.isdataUploaded === false}
										style={{width:'100%'}} 
										onChange={(value)=>{editBatch.setFieldValue('sampleSec',value);}} 
										placeholder={langdata && langdata.PleaseEntersampleSec ? langdata.PleaseEntersampleSec :'Please Enter SampleSec'}
									/>


								</Form.Item>
							</Col>
						</Row>
						<Row gutter={24}>
							<Col span={24}>
								<Form.Item name="webhookUrl" label={ langdata&&langdata.webhookUrl?langdata.webhookUrl:'webhookUrl'} rules={[{ required: false, message: langdata && langdata.PleaseEnterwebhookUrl ? langdata.PleaseEnterwebhookUrl :'Please Enter webhookUrl'}]} >
									<Input name="webhookUrl"
										defaultValue={editBatch.values.webhookUrl}
										onChange={(e) => {editBatch.setFieldValue('webhookUrl', e.target.value);}}
										placeholder={langdata && langdata.PleaseEnterwebhookUrl ? langdata.PleaseEnterwebhookUrl :'Please Enter webhookUrl'}
									/>


								</Form.Item>
							</Col>
						</Row>
					</Form>
				</Modal>



				<Modal title={langdata && langdata.Confimdelete ? langdata.Confimdelete : 'Confirm delete'} open={showDeleteBatchModal} onOk={deleteBatch} onCancel={closeDeleteBatchModal}>
					<Row style={{
						marginTop: '10px',
						marginBottom: '10px',
						background: '#FFFFFF',
						alignItems:'center'
					}} >
						<Col span={1}>
							<DeleteOutlined  style={{ fontSize: '14px'}}/>
						</Col>
						<Col span={23}> { langdata && langdata.AreYouSureYouWantToDeleteThisBatch ? langdata.AreYouSureYouWantToDeleteThisBatch : 'Are you sure you want to delete this batch' }</Col>
					</Row>
				</Modal>



					
											
			</Content>
			

			<Spin spinning={data.loading} fullscreen />
		</>
	);
}